// extracted by mini-css-extract-plugin
module.exports = {"cards":"training-profile-speed-unit_cards__1r_OK","button":"training-profile-speed-unit_button__2i7xS"};